export const HANDLE_DEEP_LINKING = 'HANDLE_DEEP_LINKING'

export const UPDATE_ENVIRONMENT = 'UPDATE_ENVIRONMENT'
